import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const InstructorEducationEditLoader = async (args: LoaderFunctionArgs) => {

    const response = await networkCall(`/educations/${ args.params.id }`);

    return { getEducationResponse: response, id: args.params.id };

};